module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("LCOHOL")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("A driver is offended when he is pulled over by a policeman and asked, “Did you know you were going fifty-five through a school zone?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The driver’s wife says, “He was going "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("seventy-five.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shut up, bitch,” says the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The officer writes two tickets, one for speeding and the other for an unfastened seat belt, and hands them to the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The driver protests, “I undid the belt to get out my license.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He never wears his seat belt,” the wife says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shut up, bitch,” says the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Does he always use this language with you?” asks the cop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wife answers, “Only when he’s been drinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Three couples are having cocktails. Two of the men urge the third to tell his new joke. He resists, saying that ladies are present and he could never tell the joke in front of ladies as it has a vulgar word at the end. They press him, saying the ladies are good sports and they wouldn’t care. He says he can’t tell that particular joke because of the terrible, tasteless end. He confesses that the punch line is also horrible and he would be too embarrassed to tell the story in front of the ladies. The two other men continue urging him. After a few more drinks he gives in, starting the joke, “Well, you see, there was this cocksuckers’ picnic.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A drunk asks a lady, “Can I smell your cunt?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shocked, horrified and disgusted, she says, “Certainly not” and moves away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk replies, slurring his words, “Well then, it must be your feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A drunk at a bar observes a slick operator sit down next to a beautiful lady. He hears the slick operator say to the beauty, “Tickle your ass with a feather.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The curvaceous doll, appalled, turns to the operator and asks angrily, “What did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The operator smiles and says, “Particularly nice weather.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She relaxes. “Oh, I misunderstood you.” They start talking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk, thinking that a great line, stumbles across the street to another establishment. He sees a sexy lady at the bar and approaches her. “Stick a feather up your ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Enraged, she asks, “What did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk countered, “’S pretty fucking cold outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The drunk businessman is terrified when he vomits on his shirt. What will his wife say? A pal suggests, “Tell her some drunk threw up on you and put fifty dollars in your shirt pocket for you to buy a new shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk businessman goes home. His wife immediately accuses him of drunkenness. He denies the accusation, saying that a drunk vomited on him and that he was so apologetic that he put fifty dollars in his shirt pocket for a new one. The wife looks in his pockets and finds two fifty-dollar bills. Accusingly, she asks him what the other bill is for. The drunk businessman says, “Oh, that must be for when he shit in my pants.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Returning from a trip, a man confides to an office pal, “It’s not the booze that gets me into trouble on these trips, it’s the women. When I come home, my wife puts me in the tub and if my balls float I’m in deep shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A drunk visits an ice-cream store and asks for a gallon of chocolate ice cream. The clerk says, “No chocolate available today.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay,” the drunk says, and asks for a quart of chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The clerk repeats, “No chocolate ice cream today.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay then,” says the drunk, “give me a pint of chocolate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The clerk, now angry, says, “I said, NO CHOCOLATE today.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well thash alright then,” the drunk says, “give me a chocolate cone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The clerk asks, “Can you spell ‘van’ in vanilla?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure,” the drunk says. “V-A-N.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Can you spell ‘straw’ in strawberry?” continues the clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk says, “Uh-huh. S-T-R-A-W.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The clerk asks, “Can you spell ‘fuck’ in chocolate?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There is no ‘fuck’ in chocolate,” replies the drunk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s what I’ve been trying to tell you,” says the clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A man asks the Irish bartender for something cold and full of gin. “Moment, sir,” the bartender says, “I’ll get my wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Three sheets to the wind, a drunk walks into a saloon and orders a “bubble dourbon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bartender says, “You mean double bourbon?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk says, “Thash what I said, bubble dourbon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After guzzling his drink, he asks for another bubble dourbon and the amused bartender asks him where he’s from.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk replies he’s in town for the “shirkey toot.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bartender says, “Oh, you mean the Turkey Shoot?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thash what I said,” the drunk counters, “shirkey toot.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bartender asks where he’s from, again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The drunk replies, “Colder Bolorado.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bartender says, “You mean Boulder, Colorado?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thash what I said,” says the drunk. “Colder, Bolorado.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bartender walks away and says to the other bartender, “Go serve that guy. He’ll shickle the tit out of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Admonished at an embassy reception by a London dowager for being a foolish old drunk and bringing irreparable disrespect and scorn to himself and his office, Churchill retorted, “Madam, you are quite ugly but in the morning I will be sober.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A hotel desk clerk gets a call at three "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("A.M.")]), _vm._v(" “What time does the bar open?” asks an inebriated caller.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Eleven-thirty in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later, the clerk receives another call from the same person, even more plastered, “What time doesh the bar open?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No change, sir. Eleven-thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An hour passes. The clerk gets yet another call, and this time the drunk’s voice is so garbled he can barely be understood. “Whatimeju shay bar opensup?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Eleven-thirty, sir. If you can’t wait, I can have room service send up something.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’ wanna gedin,” comes the reply. “I wanna gedout.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f604df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0